module.exports = __webpack_public_path__ + "static/media/homepage.6684d199.png";